import { render, staticRenderFns } from "./CSwitcherField.vue?vue&type=template&id=53936379&scoped=true&"
import script from "./CSwitcherField.vue?vue&type=script&lang=ts&"
export * from "./CSwitcherField.vue?vue&type=script&lang=ts&"
import style0 from "./CSwitcherField.vue?vue&type=style&index=0&id=53936379&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53936379",
  null
  
)

export default component.exports